module.exports = __webpack_public_path__ + "img/padlock.3580a057.svg";